import { device } from 'constants/responsive'
import styled from 'styled-components'

export const Wrapper = styled.div`
  overflow: hidden;
  width: 274px;
  height: 150px;

  background: #5786c7;
  border: 0.5px solid #d9ecf6;
  border-radius: 12px;

  @media ${device.laptop} {
    width: 100%;
  }
`

export const Header = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  text-align: center;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.8);

  padding: 16px 0;
  background: #7ea1d4;

  @media ${device.laptop} {
    padding: 8px 0;
  }
`

export const Content = styled.div`
  height: 102px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${device.laptop} {
    height: 80px;
  }
`

export const Title = styled.p`
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  color: #ffffff;
`

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.5);

  margin-top: 8px;
`
